import React, { useEffect, useRef, useState } from "react";
import { actionType } from "../../context/reducer";
import { useStateValue } from "../../context/StateProvider";
import { NavLink, useParams } from "react-router-dom";
import YouTube from "react-youtube";

import { motion } from "framer-motion";
import moment from "moment";
import { Footer, Header } from "../";
import {
  addAsFavourite,
  addNewComment,
  deleteMyComment,
  deleteMyFavourite,
  getAConceptByID,
  getAllConcepts,
  getAllFavourites,
} from "../../api";
import { Nodata } from "../../assets";
import {
  FaDiscord,
  FaDownload,
  FaGlobeAsia,
  MdCollections,
  MdDelete,
} from "../../assets/icons";
import { buttonClick, fadeInOut } from "../../utils/animations";
import { LoaderSpinner } from "../Others";

const VideoDetail = () => {
  const { concept_id } = useParams();

  const effectRun = useRef();
  const [
    { allConcepts, mainLoader, conceptDetailById, user, favourites },
    dispatch,
  ] = useStateValue();
  const [detail, setDetail] = useState(null);
  const [filtered, setFiltered] = useState(null);
  const [isFocus, setIsFocus] = useState(false);
  const [comment, setComment] = useState("");
  const [isComment, setIsComment] = useState(false);
  const [isFavourite, setIsFavourite] = useState(false);
  const [index, setIndex] = useState(5);
  const [isDiscord, setIsDiscord] = useState(false);

  useEffect(() => {
    // if (effectRun.current === true) {
    dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: true });
    if (concept_id) {
      dispatch({
        type: actionType.SET_CONCEPT_BY_ID,
        conceptDetailById: null,
      });
    }
    if (!allConcepts) {
      getAllConcepts().then((concept) => {
        dispatch({
          type: actionType.SET_CONCEPTS,
          allConcepts: concept.data,
        });
      });
    }

    if (conceptDetailById?.data.concept_id !== parseInt(concept_id)) {
      getDetailAgain();
    }

    setTimeout(() => {
      dispatch({ type: actionType.SET_MAIN_LOADER, mainLoader: false });
    }, 3000);
    // }
    return () => {
      // effectRun.current = true;
    };
  }, [concept_id]);

  const getDetailAgain = async () => {
    await getAConceptByID(concept_id).then((data) => {
      dispatch({
        type: actionType.SET_CONCEPT_BY_ID,
        conceptDetailById: data,
      });
    });

    if (!favourites) {
      await getAllFavourites(user?.user_id).then((data) => {
        dispatch({ type: actionType.SET_FAVOURITES, favourites: data.data });
      });
    }
  };

  const getMyFav = () => {
    getAllFavourites(user?.user_id).then((data) => {
      dispatch({ type: actionType.SET_FAVOURITES, favourites: data.data });
    });
  };

  const addComment = () => {
    setIsComment(true);
    if (comment.length > 0) {
      const data = {
        name: user?.name ? user?.name : user?.displayName,
        imageURL: user?.picture ? user?.picture : user?.photoURL,
        comment: comment,
        concept_id: concept_id,
        user_id: user?.user_id,
      };

      addNewComment(concept_id, data).then((data) => {
        console.log(data);
        setIsFocus(!isFocus);
        setComment("");
        getDetailAgain();
        setTimeout(() => {
          setIsComment(false);
        }, 2000);
      });
    }
  };

  const deleteComment = (ids) => {
    setIsComment(true);

    deleteMyComment(ids).then((res) => {
      setTimeout(() => {
        setIsComment(false);
      }, 2000);
    });
  };

  const markAsFavourite = () => {
    setIsFavourite(true);

    addAsFavourite(user?.user_id, conceptDetailById?.data).then((res) => {
      getMyFav();
    });
    setTimeout(() => {
      setIsFavourite(false);
    }, 2000);
  };

  const removeFavourite = () => {
    setIsFavourite(true);
    const ids = {
      user_id: user?.user_id,
      conceptId: conceptDetailById?.data.concept_id,
    };

    deleteMyFavourite(ids).then((res) => {
      getMyFav();
      setTimeout(() => {
        setIsFavourite(false);
      }, 2000);
    });
  };

  return (
    <div className="w-full h-auto flex flex-col items-center justify-center ">
      <Header />
      <div className="w-full flex items-start justify-start flex-col px-4 sm md:px-12 lg:px-48 my-3 mb-4">
        <div className="w-full grid grid-cols-1 sm:grid-cols-4">
          {/* Left container Main Player */}
          <div className="col-span-4 md:col-span-4 flex flex-col w-full gap-3">
            {/* player */}
            <div className="w-full rounded-md overflow-hidden">
              <YoutubePlayer
                setFiltered={setFiltered}
                videoId={
                  conceptDetailById?.data.videoURL.split("/")[
                    conceptDetailById?.data.videoURL.split("/").length - 1
                  ]
                }
              />
            </div>
            {/* concept name */}
            <p className="text-textColor text-xl font-semibold">
              {conceptDetailById?.data.video_name}
            </p>

            {/* concepts options  */}
            {user ? (
              <div className=" w-full  flex items-center justify-end flex-wrap gap-6 flex-row-reverse gap-y-3">
                {isFavourite ? (
                  <>
                    <LoaderSpinner />
                  </>
                ) : (
                  <>
                    {favourites &&
                    favourites?.filter((n) =>
                      n.concept_id.includes(conceptDetailById?.data.concept_id)
                    ).length > 0 ? (
                      <motion.div
                        {...buttonClick}
                        onClick={removeFavourite}
                        className="flex items-center gap-1 cursor-pointer"
                      >
                        <MdCollections className=" -rotate-0 text-red-500" />
                        <p className="text-base text-red-500 font-semibold">
                          Saved
                        </p>
                      </motion.div>
                    ) : (
                      <motion.div
                        {...buttonClick}
                        onClick={markAsFavourite}
                        className="flex items-center gap-1 cursor-pointer"
                      >
                        <MdCollections className=" -rotate-0 text-red-500" />
                        <p className="text-base text-red-500 font-semibold">
                          Save
                        </p>
                      </motion.div>
                    )}
                  </>
                )}

                {conceptDetailById?.data.liveURL.length > 0 && (
                  <motion.button
                    {...buttonClick}
                    onClick={() => {
                      window.open(
                        `${conceptDetailById?.data.liveURL}`,
                        "_blank"
                      );
                    }}
                    className="px-4 py-1 flex items-center justify-center gap-3 rounded-md  border border-gray-200 outline-none cursor-pointer hover:shadow-md text-textColor"
                  >
                    <FaGlobeAsia className=" -rotate-0 text-textColor" />
                    Live URL
                  </motion.button>
                )}

                {conceptDetailById?.data.github.length > 0 && (
                  <motion.button
                    {...buttonClick}
                    onClick={() => {
                      window.open(
                        `${conceptDetailById?.data.github}`,
                        "_blank"
                      );
                    }}
                    className="px-4 py-1 flex items-center justify-center gap-3 rounded-md  border border-gray-200 outline-none cursor-pointer hover:shadow-md text-textColor"
                  >
                    <FaDownload className=" -rotate-0 text-textColor" />
                    Source
                  </motion.button>
                )}

                <img
                  src={conceptDetailById?.data.trainer?.thumb}
                  className=" w-10 h-10 rounded-md shadow-md object-cover"
                  referrerPolicy="no-referrer"
                />
              </div>
            ) : (
              <>
                <NavLink
                  to={"/login"}
                  className=" w-full px-12 flex items-center justify-center"
                >
                  <p className=" w-full px-4 rounded-md py-2 text-lg text-primary font-semibold tracking-wider my-4 bg-pink-400 shadow-md flex items-center justify-center ">
                    Login to Download & Comment
                  </p>
                </NavLink>
              </>
            )}

            {/* cmments sections */}
            <p className="text-2xl text-textColor font-semibold mt-6">
              Comments
            </p>
            {user && (
              <div className=" w-full flex-col flex gap3 gap-y-3">
                <p className="text-lg text-textColor font-semibold">
                  Add New Comment
                </p>
                <div className=" w-full flex flex-col gap-3 items-center">
                  <div className="flex w-full items-center gap-3">
                    <img
                      src={user?.picture ? user?.picture : user?.photoURL}
                      className="w-12 h-12 rounded-full object-cover"
                      alt=""
                      referrerPolicy="no-referrer"
                    />
                    <div className=" w-full flex flex-col">
                      <input
                        type="text"
                        placeholder="New comment..."
                        className=" w-full outline-none border-none text-lg text-textColor p-3"
                        onFocus={() => setIsFocus(!isFocus)}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                      />
                      <div
                        className={`w-full h-[2px] duration-150 ease-in-out transition-all  ${
                          isFocus ? "bg-gray-500" : "bg-gray-200"
                        }`}
                      ></div>
                    </div>
                  </div>
                  {isFocus && (
                    <motion.div
                      {...fadeInOut}
                      className=" w-full flex items-end justify-end gap-3"
                    >
                      <motion.button
                        {...buttonClick}
                        className="px-4 py-1 border border-gray-200 rounded-md text-textColor text-base cursor-pointer hover:shadow-md"
                        onClick={() => setIsFocus(!isFocus)}
                      >
                        Cancel
                      </motion.button>
                      <motion.button
                        {...buttonClick}
                        className="px-4 py-1 border border-gray-200 rounded-md text-textColor text-base cursor-pointer hover:shadow-md"
                        onClick={addComment}
                      >
                        Comment
                      </motion.button>
                    </motion.div>
                  )}
                </div>
              </div>
            )}

            <div className=" w-full flex flex-col items-center justify-center my-8 gap-3">
              {isComment && <LoaderSpinner />}
              <div className=" w-full flex flex-col items-center justify-center gap-2">
                {conceptDetailById?.commentsData.length > 0 ? (
                  conceptDetailById?.commentsData.map((n, i) => (
                    <div
                      key={i}
                      className=" w-full hover:shadow-sm flex gap-3 items-center p-3 border border-gray-200 rounded-md relative"
                    >
                      <img
                        src={n.imageURL}
                        className="w-12 h-12 rounded-full object-cover"
                        alt=""
                        referrerPolicy="no-referrer"
                      />

                      <div className=" w-full flex flex-col gap-2">
                        <p className="text-lg flex items-center gap-3 text-textColor font-semibold">
                          {n.name}
                          <span className="text-sm text-textColor">
                            {moment(
                              new Date(parseInt(n.comment_id)).toISOString()
                            ).fromNow()}
                          </span>
                        </p>
                        <p className="text-base text-textColor">{n.comment}</p>
                      </div>

                      {(user?.user_id === process.env.REACT_APP_GMAIL_USER_ID ||
                        user?.user_id ===
                          process.env.REACT_APP_GITHUB_USER_ID ||
                        user?.user_id === n?.user_id) && (
                        <motion.div
                          {...buttonClick}
                          className="cursor-pointer  absolute right-2 top-2"
                          onClick={() =>
                            deleteComment({
                              videoId: n?.concept_id,
                              commentId: n?.comment_id,
                            })
                          }
                        >
                          <MdDelete className="-rotate-0 text-red-500 text-xl" />
                        </motion.div>
                      )}
                    </div>
                  ))
                ) : (
                  <>
                    <img src={Nodata} className=" w-96" />
                    <p className="text-2xl font-semibold text-textColor">
                      No Comments
                    </p>
                  </>
                )}
              </div>
            </div>
          </div>
          {/* suggestion sections */}
          {/* <div className="col-span-4 md:col-span-1  rounded-md md:ml-3 hidden md:flex flex-col gap-3 p-1">
            {filtered ? (
              filtered?.slice(0, index).map((data, i) => (
                <NavLink key={i} to={`/videoDetail/${data.concept_id}`}>
                  <div className=" w-full flex flex-col gap-2 relative cursor-pointer hover:shadow-md p-2 rounded-md">
                    <img
                      src={data.video_thumb}
                      className=" w-full rounded-md object-cover"
                      alt=""
                    />
                    <p className="text-sm text-textColor font-semibold">
                      {data.video_name.length > 30
                        ? `${data.video_name.slice(0, 30)}...`
                        : data.video_name}
                    </p>
                  </div>
                </NavLink>
              ))
            ) : (
              <>
                <div className="w-full h-full flex flex-col items-center justify-start gap-3">
                  <img src={Nodata} className=" w-full" alt="" />
                  <p className="text-lg text-textColor font-semibold">
                    No sugesstions found
                  </p>
                </div>
              </>
            )}

            {filtered && (
              <motion.div
                {...buttonClick}
                className="flex items-center justify-center cursor-pointer bg-red-300 rounded-md shadow-md px-4 py-2"
                onClick={() => setIndex(index + 5)}
              >
                <p>Load More</p>
              </motion.div>
            )}
          </div> */}
        </div>
      </div>
      <a
        href="https://discord.gg/TsydV9XUJe"
        className=" fixed z-50 bottom-32 right-8 px-4 py-2  rounded-md flex  items-start
         gap-3 bg-blue-400 shadow-lg"
        target="_blank"
        onMouseEnter={() => setIsDiscord(true)}
        onMouseLeave={() => setIsDiscord(false)}
      >
        <FaDiscord className=" -rotate-0 text-4xl text-primary" />
        {isDiscord && (
          <motion.p
            {...fadeInOut}
            className="text-base text-textColor w-44 absolute bottom-16 -left-24 backdrop-blur-lg px-3 py-2 bg-card font-semibold rounded-md shadow-md"
          >
            {" "}
            Join our community
          </motion.p>
        )}
      </a>
      <Footer />
    </div>
  );
};

export const YoutubePlayer = ({ videoId, setFiltered }) => {
  const [{ allConcepts, mainLoader, conceptDetailById }, dispatch] =
    useStateValue();
  const opts = {
    height: "450",
    width: "100%",
    // playerVars: {
    //   // https://developers.google.com/youtube/player_parameters
    //   autoplay: 1,
    // },
  };
  const _onReady = (event) => {
    event.target.pauseVideo();
    // if (allConcepts) {
    //   const filteredData = allConcepts?.filter(
    //     (data) => data.concept_id !== conceptDetailById?.data.concept_id
    //   );
    //   setFiltered(filteredData.length > 0 ? filteredData : null);
    // }
  };
  return (
    <>
      <YouTube videoId={videoId} opts={opts} onReady={_onReady} />
    </>
  );
};

export default VideoDetail;
